import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "L’Élite",
    tagline: "Fire, refined.",
    description: "L’Élite is a fire-led Mediterranean restaurant with French technique and a zero-proof bar in Marylebone. Fire, refined.",
    url: getOrigin(),
    contact: {
        street: "11 Ember Court",
        area: "Marylebone",
        city: "London",
        postcode: "W1U 6AB",
        phone: "+44 20 7946 0213",
        phoneHref: 'tel:+442079460213',
        instagram: 'https://www.instagram.com/lelite.fire',
        instagramHandle: "@lelite.fire",
        maps: 'https://www.google.com/maps/search/?api=1&query=11%20Ember%20Court%2C%20Marylebone%2C%20London%20W1U%206AB'
    },
    hours: [
        { days: "Mon – Thu", daysLong: "Monday to Thursday", open: '12:00', close: '23:00' },
        { days: "Fri – Sat", daysLong: "Friday and Saturday", open: '12:00', close: '00:00' },
        { days: "Sun", daysLong: "Sunday", open: '12:00', close: '22:00' }
    ],
    nav: [
        { label: "Menu", href: '/menu' },
        { label: "Sans Alcool", href: '/sans-alcool' },
        { label: "La Maison", href: '/la-maison' },
        { label: "The Room", href: '/the-room' },
        { label: "Private Dining", href: '/private-dining' }
    ]
}

export const HALAL_LINE = "Halal. No alcohol. No pork. Everyone is welcome."
